import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/dashboard/services/user.service';
import { SegmentacionEnum } from 'src/app/shared/enums/segmentacion.enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dialog-assign-points',
  styleUrls: ['./dialog-assign-points.component.sass'],
  templateUrl: './dialog-assign-points.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DialogAssignPointsComponent implements OnInit {
  spotPoints: number =0;
  segmentationId : number = 1;

  constructor( public dialogRef: MatDialogRef<DialogAssignPointsComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any[], private userService: UserService, private spinner: SpinnerService) {

     }
  ngOnInit(): void {
    this.segmentationId= 1;
  }
     async editSegmentation(){
      const ref = this.spinner.start();
      const validIds = this.data.filter((user: any) => user.segmentacionId !== SegmentacionEnum.RETAIL);
      const ids = validIds.map((user: any) => user.usuarioId);
      try {
        await this.userService.increaseSpotPoints(ids, this.spotPoints);
        this.spinner.stop(ref);
        Swal.fire('Éxito', 'Puntos Spot Actualizados', 'success');
        this.dialogRef.close(true);
      } catch (error) {
        this.spinner.stop(ref);
        Swal.fire('Error', 'Ocurrió un error al actualizar la segmentación', 'error');
      }

     }
 }
